__turbopack_context__.v({
  "item": "SuG5aW_item",
  "vertical": "SuG5aW_vertical",
  "verticalItems": "SuG5aW_verticalItems",
});
